<template>
  <div>
    <UserKpi
      :kpiIds="config.link_data"
      :kpiBackgrounds="config.property_data"
    ></UserKpi>
  </div>
</template>

<script>
import UserKpi from "@/plugin/cms/UserKpi";

export default {
  name: "tms-user-kpi",
  props: ["config", "isEditorStatus"],
  data() {
    return {};
  },
  components: {
    UserKpi,
  },
  mounted() {},
  methods: {},
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>